function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".st0{fill:none;stroke:#3c00dc}");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "Group_157",
  transform: "translate(-660.26 -3268.159)"
}, /*#__PURE__*/React.createElement("path", {
  id: "Path_3",
  className: "st0",
  d: "M740.1 3420.3h78l-14.5-30.3h-83.5l20 30.3z"
}), /*#__PURE__*/React.createElement("path", {
  id: "Path_8",
  className: "st0",
  d: "M832.7 3450.6H863l-85.8-182h-30.3l-85.8 182h30.3l70.7-149.4 40.4 86.3 30.2 63.1z"
}));

function SvgAtendeOutlinedinline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Warstwa_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 203.6 183",
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
}

export default SvgAtendeOutlinedinline;